export const arrayVersionToNumber = (lVersions: string[]) => {
  const [major, minor, patch] = lVersions;
  return (
    Number(major || 0) * 1000 * 1000 +
    Number(minor || 0) * 1000 +
    Number(patch || 0)
  );
};

export const versionToNumber = (v = '0.0.0') => {
  if (v === null) v = '0.0.0';
  if (typeof v === 'number') return v;

  return arrayVersionToNumber(v.split('.'));
};

export const versionIsGreaterThanOrEqual = (
  currentAppVersion = '0.0.0',
  targetVersion = '0.0.0'
) => {
  return versionToNumber(currentAppVersion) >= versionToNumber(targetVersion);
};
